import { NewTable } from 'components/shared/commonTable/Table'
import React, { useCallback, useEffect, useState } from 'react'
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';
import styles from "../Announcements.module.scss"
import Button from 'components/shared/button/Button';
import dayjs from 'dayjs';
import { InputAdornment, TextField } from '@mui/material';
import { Search } from '@mui/icons-material';
import { useFormHandler } from 'components/pages/hierarchy/hooks/useFormHandler';
import toast from 'react-hot-toast';
import { ANNOUNCEMENT } from 'services/apiEndpoints';
import { useParams } from 'react-router-dom';
import { throttle } from 'lodash';
import Modal from 'components/shared/modal/Modal';
import ArchiveProjectIcon from "assets/svg/ArchiveTaskIcon.svg";
import WarningIcon from "assets/svg/warning.svg";
import { permissionsDenied } from 'utils/permission';
import { getUserAccess } from 'utils/utils';

const column = [
    {
        name: "User",
        selector: row => `${row.user?.firstName} ${row.user?.lastName}`
    },
    {
        name: "Role",
        selector: row => row.user?.role?.name
    },
    {
        name: "Company Name",
        selector: row => row.creator || "-"
    },
];

const openedColumns = [
    ...column,
    {
        name: "Date Read",
        selector: row => row?.openedAt ? dayjs(row.openedAt.slice(0, -1)).format('MMMM D, h:mm A [GMT]Z') : null
    },
];

const Summary = ({ data, loading, recipientType, announcementType = "sent", openedCount }) => {
    const { id } = useParams()
    const [nonopenermodal, setNonopenermodal] = useState(false)
    const [value, setValue] = useState(0);
    const [filteredData, setFilteredData] = useState([]);
    const [unOpened, setUnOpened] = useState([]);

    const { saveDetails } = useFormHandler()

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };
    function a11yProps(index) {
        return {
            id: `simple-tab-${index}`,
            "aria-controls": `simple-tabpanel-${index}`,
        };
    }

    const handleSearch = (e) => {
        const val = e.target.value
        setFilteredData(data?.filter(ele => {
            return ele.status === (value ? "unopened" : "opened") && `${ele.user?.firstName} ${ele.user?.lastName}`?.toLowerCase()?.includes(val?.toLowerCase())
        }))
    }


    const handleResend = useCallback(
        throttle(async (e) => {
            e.stopPropagation();
            try {
                // /announcement/$id/resend/non-openers
                await saveDetails(
                    `${ANNOUNCEMENT}/${id}/resend/non-openers`,
                    {},
                    null,
                    () => {
                        toast.success("Resend to Non-openers");
                    }
                );
            } catch (error) {
                console.log("Error while saving", error);
            }
        }, 2000), // Throttle with a 2-second delay
        []
    );

    useEffect(() => {
        if (data) {
            setFilteredData(data?.filter(ele => ele.status === (value ? "unopened" : "opened")))
            setUnOpened(data?.filter(ele => ele.status === "unopened"))
        }
    }, [data, value])
    
    return (
        <>
            <div className={styles.summaryContainer}>
                <h5>Summary</h5>
                <div className={styles?.topBar}>
                    <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                        <Tabs value={value} onChange={handleChange} aria-label="basic tabs example">
                            <Tab label="OPENED" {...a11yProps(0)} />
                            <Tab label="UNOPENED" {...a11yProps(1)} />
                        </Tabs>
                    </Box>
                    <Box
                        sx={{
                            display: "flex",
                            alignItems: "center",
                            gap: ".5rem"
                        }}
                    >
                        <TextField
                            id="input-with-icon-textfield"
                            label="Search"
                            onChange={handleSearch}
                            variant="filled"
                            sx={{
                                backgroundColor: "rgb(228, 228, 228)"
                            }}
                            slotProps={{
                                input: {
                                    startAdornment: (
                                        <InputAdornment position="start">
                                            <Search />
                                        </InputAdornment>
                                    ),
                                },
                            }}
                        />
                        {
                            !permissionsDenied[getUserAccess()]?.includes("resendAnnouncement") && (
                            announcementType === "sent" &&
                            <Button
                                className={styles.resend}
                                label="RESEND TO NON-OPENERS"
                                onClick={() => setNonopenermodal(true)}
                            >
                                <span style={{ fontSize: "13px" }}>RESEND TO NON-OPENERS</span>
                            </Button>
                        )}
                    </Box>
                </div>
                <div className={styles?.summary}>
                    <NewTable
                        columns={value === 0 ? openedColumns : column}
                        data={filteredData}
                        progressPending={loading}
                        paginationTotalRows={filteredData?.length}
                        pagination
                    />
                </div>
            </div>
            <Modal
                modalOpen={nonopenermodal}
                onSubmit={handleResend}
                setModalOpen={setNonopenermodal}
                heading={"Resend to Non openers"}
                icon={openedCount === data?.length ? WarningIcon : ArchiveProjectIcon}
                children={
                    openedCount === data?.length ?
                        "There is no opener for this Announcemnet"
                        :
                        `Do you want to Boradcast this announcmenet to ${unOpened.length} Users`
                }
                isOk={openedCount === data?.length}
                isCancel={true}
            />
        </>
    )
}

export default Summary